import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import "./style.css";
import { setCurrentUser } from "../../actions/currentUserActions";
import { auth } from "../../firebase/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import { getAlbumCollection, getMyAlbums } from "../../firebase/firestore";
import {
  setAlbumsAutorizados,
  setMiAlbum,
  updateFiguritas,
} from "../../actions/figuritasActions";
import { defaultAlbum } from "../../data";
import LoginOptions from "./LoginOptions";

export default function PageContent({ children }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const album = useSelector((state) => state.figuritasReducer.figuritas);
  const currentUser = useSelector((state) => state.currentUser.user);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      dispatch(setCurrentUser(user));
      if (user) {
        if (!album) {
          setLoading(true);
          getMyAlbums(user.email).then((result) => {
            dispatch(setAlbumsAutorizados(result));
          });
          getAlbumCollection(user, dispatch).then((result) => {
            setLoading(false);
            dispatch(
              setMiAlbum(
                result || {
                  ...defaultAlbum,
                  owner: {
                    name: user.displayName,
                    email: user.email,
                    uid: user.uid,
                  },
                }
              )
            );
            if (result) {
              dispatch(updateFiguritas(result));
            } else {
              dispatch(
                updateFiguritas({
                  ...defaultAlbum,
                  owner: {
                    name: user.displayName,
                    email: user.email,
                    uid: user.uid,
                  },
                })
              );
            }
          });
        }
      }
    });
  }, []);

  return (
    <div className="mainContainer">
      <Navbar />
      <main>
        {loading && <span className="loader"></span>}
        {currentUser ? children : <LoginOptions />}
      </main>
      <footer></footer>
    </div>
  );
}
